import { render } from "./StatsTOC.vue?vue&type=template&id=8f4c26d8"
import script from "./StatsTOC.vue?vue&type=script&lang=js"
export * from "./StatsTOC.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__